import Vue from 'vue';
import defaultApiResultManager from '@/core/shared/defaultApiResultManager';
import { PassengerMapper } from '@/shared/mappers/passenger.mapper';

export default {
  createPassenger(payload) {
    return Vue.http
      .post(`api/passengers`, PassengerMapper.toDTO(payload))
      .then(({ data }) => {
        Vue.notify(defaultApiResultManager.then(`Pasażer ${data.name} został poprawnie dodany`));
        // TODO: init user wasn't called
        return data;
      })
      .catch(({ status, data }) => {
        Vue.notify(
          defaultApiResultManager.catch(data, status, data.message ? data.message : 'Wystąpił błąd dodawania')
        );

        throw data;
      });
  },

  updatePassenger(payload) {
    return Vue.http
      .put(`api/passengers/${payload.entity.id}`, PassengerMapper.toDTO(payload))
      .then(({ data }) => {
        Vue.notify(defaultApiResultManager.then());
        return data;
      })
      .catch(({ status, data }) => {
        Vue.notify(defaultApiResultManager.catch(data, status, data.message ? data.message : 'Wystąpił błąd edycji'));

        throw data;
      });
  },

  deletePassenger(payload) {
    return Vue.http
      .delete(`api/users/${payload.user.id}`)
      .then(() => {
        Vue.notify(defaultApiResultManager.then(`Pasażer ${payload.name} został usunięty`));
      })
      .catch(({ status, data }) => {
        Vue.notify(defaultApiResultManager.catch(data, status, data.message ? data.message : 'Wystąpił błąd usuwania'));

        throw data;
      });
  },

  fetchPassengerById(id) {
    return Vue.http
      .get(`api/passengers/${id}`)
      .then(({ data }) => data)
      .catch(({ status, data }) => {
        Vue.notify(defaultApiResultManager.catch(data, status, 'Wystąpił błąd podczas ładowania'));

        throw data;
      });
  },
};
